import React from 'react';
import { useLocation } from 'react-router-dom';

import Grid from '@mui/material/Grid2';

import { DebriefAircraft, TailNumber } from 'ff/debrief/models';
import { useCurrentAircraft, useAnalytics } from 'ff/debrief/hooks';
import { getCurrentPage } from 'ff/debrief/utils';

import TailNumberField from './TailNumberField';
import AircraftModelField from './AircraftModelField';

const AircraftForm = () => {
    const location = useLocation();
    const { logEvent } = useAnalytics();
    const {
        currentTailNumber,
        currentAircraft,
        updateTailNumber,
        setAircraftModel,
    } = useCurrentAircraft();

    const [tailFieldDisabled, setTailFieldDisabled] = React.useState(false);
    const [aircraftFieldDisabled, setAircraftFieldDisabled] =
        React.useState(false);

    const handleTailChange = (newTail: TailNumber) => {
        setTailFieldDisabled(true);
        const previousTail = currentTailNumber?.tailNumber;
        updateTailNumber(newTail?.tailNumber || '').then(() => {
            logEvent('Debrief, Tail Number Changed', {
                previousTail,
                newTail: newTail?.tailNumber || null,
                newManufacturer: newTail?.manufacturer || null,
                newModel: newTail?.model || null,
                currentPage: getCurrentPage(location.pathname),
            });
            setTailFieldDisabled(false);
        });
    };

    const handleAircraftModelChange = (newModel: DebriefAircraft) => {
        setAircraftFieldDisabled(true);
        const previousModel = currentAircraft;
        setAircraftModel(newModel)
            .then(() => {
                logEvent('Debrief, Aircraft Model Changed', {
                    previousManufacturer: previousModel?.manufacturer || null,
                    previousModel: previousModel?.model || null,
                    newManufacturer: newModel?.manufacturer || null,
                    newModel: newModel?.model || null,
                    isCustom: newModel?.model.toLocaleUpperCase() === 'CUSTOM',
                    currentPage: getCurrentPage(location.pathname),
                });
                setAircraftFieldDisabled(false);
            })
            .catch(() => {
                setAircraftFieldDisabled(false);
            });
    };

    return (
        <Grid container mb={2}>
            <Grid size={5}>
                <TailNumberField
                    value={currentTailNumber}
                    onChange={handleTailChange}
                    disabled={tailFieldDisabled}
                />
            </Grid>
            <Grid size={7}>
                <AircraftModelField
                    value={currentAircraft}
                    onChange={handleAircraftModelChange}
                    disabled={aircraftFieldDisabled}
                />
            </Grid>
        </Grid>
    );
};

export default AircraftForm;
